
define(
'PDPTermsAndCoverage.Main'
,   [
	'Terms.View',
	'Coverage.View'
	]
,   function (
	MainView,
	CoverageView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{

			var pdp = container.getComponent('PDP');
			var plp = container.getComponent('PLP');

			if (plp) {
				plp.addChildViews(
					plp.PLP_VIEW, {
						'Facets.Browse.CategoryHeading': {
							'CoverageView': {
								childViewIndex: 11,
								childViewConstructor: function coverageChildView() {
									return new CoverageView({ container:container });
								}
							}
						}
					}
				);
			}

			pdp.addChildViews(
			    pdp.PDP_FULL_VIEW
			    , {
			        'Product.Sku':
			        {
			            'TermsView':
			            {
			                childViewIndex: 1
			            ,   childViewConstructor: function ()
			                {
			                    return new MainView({container:container});
			                }
			            }
			        }
			    }
			);
			pdp.addChildViews(
			    pdp.PDP_FULL_VIEW
			    , {
			        'Product.Sku':
			        {
			            'CoverageView':
			            {
			                childViewIndex: 1
			            ,   childViewConstructor: function ()
			                {
			                    return new CoverageView({container:container});
			                }
			            }
			        }
			    }
			);

		}
	};
});
